export default __webpack_public_path__ + "static/literature-reference-desktop-6bc1a434f027055bac2544774ed10622.png";